export default __webpack_public_path__ + "media/images/theme/bg_dark-562a9e94f28f5deb348fc7c9f3872952.png";